import Vue from 'vue'
import Vuex from 'vuex'

import bankSlip from './bankSlip'
import cardDuplicate from './cardDuplicate'
import confirmMessage from './confirmMessage'
import formRules from './formRules'
import irpf from './irpf'
import plans from './plans'
import request from './request'
import router from '@/router'
import userDataUpdate from './userDataUpdate'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    bankSlip,
    cardDuplicate,
    confirmMessage,
    formRules,
    irpf,
    plans,
    request,
    router,
    userDataUpdate
  },
  state: {
    "tokenSms": "CORPORE-ey?J0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6IjdlMmFlZThiYTYwMmRiMTRmMDAzY2IwMjViYTUzYTllYjgxYTQ1MjU4MjQzMGI4YTZhZDUwMjQ4NmI2MWM1ZmRkMjFkOWQ3MzBlZTlkZGI1In0.eyJhdWQiOiI0IiwianRpIjoiN2UyYWVlOGJhNjAyZGIxNGYwMDNjYjAyNWJhNTNhOWViODFhNDUyNTgyNDMwYjhhNmFkNTAyNDg2YjYxYzVmZGQyMWQ5ZDczMGVlOWRkYjUiLCJpYXQiOjE1NzE5MjI4NzUsIm5iZiI6MTU3MTkyMjg3NSwiZXhwIjoxNjAzNTQ1Mjc1LCJzdWIiOiIxIiwic2NvcGVzIjpbXX0.MxqsZgMT1h0CxlROTcB66u1JIqWYLNrzemNqGcW9df_qlhE_KiKGlRQcSDveiksrChy9j9ObOj-CgkNGKjIxifaEzti2SSDKo9AIY6_sClosgUwA-IfYvj_QfiK711aQ16E1_5_X02A6xwPg63hs-Dk3mVKx15_aAhjK_dSaNn8OhhhsgrIJdDThvNr2btfHo4ELx8i6tvrhjBBv9Cu9H0gY6SbSV54lxMOfUNsZciHTpgf0wc9NyuuUIjxcLtWt7jwNmK3r8LCNKb9ivbxYYF9APYjPhOc_Q-Ze3uw_wJl3UWlrR_VvkUh1uPeQ70_f0L5rFs-9mlm7BDuNBRbPvXoiDRrmAXWyaesd9R_OM_bQlfKmrET-hqBcyk_fr8VgbYaRuGk5wdRyx84vFasty_qI7zeeASxOATd8jA1bmJIZO5sfpZczGvxORltA6s7mPHXbHXqpRnksO_qLzesHPR5aUXjWzbK5pJ3th0PpG1wv4PJWemhRdaG2SAWzHwOqrqTuTvTaWvNKgkJ4FhpQSmxyh6v2LT3pbjWiMlTKEcepQs2EpX6NGw516WV-Jk49omPrR-c--YFXsSzT5InHvHdxyDdld4fNMNTqSJyxUvbxxFlVjR0yc0fVLC0T_ILBch953ApTWPZeJLjlxn9IzinjUWGtFLN9p6xhc7N9D7A",
    "ey": "16a560ebf5109f66df926bdf1eed016f",
    permissionsUser: {},
    config: {
      logo: {
        src: './img/logo.png',
        title: 'Corpore Administradora'
      },
      selo1: {
        src: './img/selo-campea.png',
      }
    },
    userLoged: {},
    loader: {
      loaderOn: false,
      linearLoader: true,
      circleLoader: false
    },
    snack: {
      snackbarShow: false,
      snackMessage: '',
      timeout: null,
      typeSnack: ''
    },
    showMenu: false
  },
  actions: {
  },
  mutations: {
    toggleMenu: (state, opts) => {
      state.showMenu = !opts ? !state.showMenu : (opts == 'show' ? true : false)
    },
    updateUserLoged: (state, obj) => {
      state.userLoged = obj
    },
    showLoader: (state, opts) => {
      if (opts && opts.circle) {
        state.loader.linearLoader = false
        state.loader.circleLoader = true
      } else {
        state.loader.linearLoader = true
        state.loader.circleLoader = false
      }
      state.loader.loaderOn = true
    },
    hideLoader: state => (state.loader.loaderOn = false),
    showAlert: (state, opts) => {
      state.snack.snackbarShow = true
      state.snack.snackMessage = opts.message
      state.snack.timeout = opts.time
      state.snack.typeSnack = opts.type
    }
  }
})
